/**
 * Given LatLng for the center point, will offset the center in any direction in
 * pixels. This is useful if you have a marker, label, or something and you have
 * a specific point you want to place it (such as under the cursor) but you want
 * to add some spacing so its not in the way of something (liket he cursor).
 *
 * @param {google.maps.Map} map A Google Map Map instance
 * @param {google.maps.LatLng} centerPoint The center point to offset from in a
 *   LatLng type
 * @param {number} [offsetX] The distance you want that point to move to the
 *   right, in pixels
 * @param {number} [offsetY] The distance you want that point to move upwards,
 *   in pixels
 *
 * @returns {google.maps.LatLng} Returns an offset LatLng from the centerPoint given
 */
export default function offsetCenter(map, centerPoint, offsetX, offsetY) {
    var scale = Math.pow(2, map.getZoom());
    var worldCoordinateCenter = map
        .getProjection()
        .fromLatLngToPoint(centerPoint);
    var pixelOffset = new google.maps.Point(offsetX / scale || 0, offsetY / scale || 0);
    var worldCoordinateNewCenter = new google.maps.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
    return map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
}
